import { loadConfig, getApiUrlSync } from "../config/appConfig";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

export const loginMicrosoft = async () => {
  const rota = await loadConfig();

  window.location.href = `${rota.API_URL}/api/auth/microsoft/login`;
};

export const loginGoogle = async () => {
  const rota = await loadConfig();

  window.location.href = `${rota.API_URL}/api/auth/google/login`;
};

// Evita registrar "Sessão encerrada" duplicado quando o próprio logout() (que já grava seu log)
let logoutIniciado = false;

/** Faz logout no servidor ao fechar a aba/janela. keepalive permite concluir após unload. */
export const marcarSessaoInativa = () => {
  if (logoutIniciado) return;

  const base = getApiUrlSync();
  if (!base) return;

  sessionStorage.removeItem('llr');

  sessionStorage.setItem('_wasRefresh', 'true');

  try {
    const url = `${base}/auth/sessao/inativa`;

    if (navigator.sendBeacon) {
      navigator.sendBeacon(url);
    } else {
      fetch(`${base}/auth/sessao/inativa`, {
        method: 'POST',
        credentials: 'include',
        keepalive: true,
      });
    }
  } catch (_) {
    /* ignora: não vai capturar a exceção por estar fechando a janela */
  }
};

export const enviarHeartbeat = async () => {
  const rota = await loadConfig();
  try {
    const response = await fetch(`${rota.API_URL}/auth/heartbeat`, {
      method: 'POST',
      credentials: 'include',
    });
    if (response.status === 401) {
      window.location.href = '/login';
    }
  } catch (_) { }
};

export const logout = async () => {
  logoutIniciado = true;
  const rota = await loadConfig();

  console.log("LOGOUT EXECUTADO");

  sessionStorage.clear();
  localStorage.clear();

  try {
    const userInfo = await checkAuth();
    const key = `marcados_${userInfo.user.id}`;
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Erro ao realizar logout:", error);
  } finally {
    window.location.href = `${rota.API_URL}/auth/logout`;
  }
};

export const checkAuth = async () => {
  try {
    const rota = await loadConfig();
    const wasRefresh = sessionStorage.getItem('_wasRefresh');
    sessionStorage.removeItem('_wasRefresh');
    const url = `${rota.API_URL}/auth/usuarioLogado${wasRefresh ? '?reload=true' : ''}`;

    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
      redirect: 'manual'
    });

    if (response.type === 'opaqueredirect') {
      return { isAuthenticated: false, user: null };
    }

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    return { isAuthenticated: false, user: null };
  } catch (error) {
    return { isAuthenticated: false, user: null };
  }
};

export const getCurrentUser = async () => {
  const auth = await checkAuth();
  return auth.isAuthenticated ? auth.user : null;
};

export default {
  loginMicrosoft,
  loginGoogle,
  logout,
  checkAuth,
  getCurrentUser
};

